/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>permissions.service.ts</name>
///
/// <description>
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>21 Jan 2018</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 18Jan21 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Injectable} from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import {HydUser} from "../../models/user";
import {hydUtilService} from "../../utils/hydUtils.service";
import {Environment} from '../../host.environment'; 
import { Subscription } from 'rxjs/Subscription';
import { HydrogenAppConfigService } from '../../host.config.service'; 
import { Observable } from 'rxjs/Observable';
 import { Subject } from 'rxjs/Subject';
 import { UserAPIService, HydrogenUser} from '../../services/Crestron.HydrogenAPI.UserApi.service';
 import { AccountApiService, AccountDetail, Feature} from '../../services/Crestron.HydrogenAPI.AccountApi.service';

@Injectable()
export class PermissionsService {
    
    public permissions: Array<any> = new Array<any>();
    public tier: string;
    private account: AccountDetail;
    public ready: boolean = false;
     
     //----------------------------------------------------------
    //constructor
    //----------------------------------------------------------
    constructor(private userAPIService: UserAPIService,
        private accountApiService: AccountApiService,
        private hydUser: HydUser ) {
         
                           
    }

     //----------------------------------------------------------
    //Start
    //----------------------------------------------------------
    public Start() { 

        if (this.hydUser && this.hydUser.UserId) {
              this.reload(); 
        }
              

    }
    //----------------------------------------------------------
    //init
    //----------------------------------------------------------
    public reload() {
        
        if (sessionStorage["permissions"]) {
            this.permissions = JSON.parse(sessionStorage["permissions"]);
        }
        if (sessionStorage["tier"]) {
            this.tier = JSON.parse(sessionStorage["tier"]);
        }
         
    }
     //----------------------------------------------------------
    //init
    //----------------------------------------------------------
    public init(): Promise<void> {

      

        let inst = this;
        return new Promise<void>(function (resolve, reject) {
            //Get User
            inst.userAPIService.getUserById(inst.hydUser.UserId).subscribe(
                user => {

                    //Get Account
                    let obs1 = inst.accountApiService.getAccountById(user.accountId).subscribe(
                        account => {
                            obs1.unsubscribe();
                            inst.account = account;

                            //Get Features
                          let obs2 = inst.accountApiService.getFeatures(account.tier, user.role, user.accountId).subscribe(
                                features => {
                                    obs2.unsubscribe();

                                    //Fill Permissions
                                    inst.tier = account.tier;
                                    if (features && features.length > 0) {

                                        let sub = inst;
                                        features.forEach(function (item) {
                                            sub.addPermission(item);
                                        });

                                        resolve();

                                    }
                                    else {

                                    }
                                },
                                error => {
                                    obs2.unsubscribe();

                                }

                            );
                        },
                        error => {
                            obs1.unsubscribe();

                        }
                    );


                },
                error => {

                }
            );

        });

      


    } 
     
     //----------------------------------------------------------
    //addPermission
    //----------------------------------------------------------
    public addPermission(permission: Feature) {

        this.permissions.push(permission);

    }
    //----------------------------------------------------------
    //removePermission
    //----------------------------------------------------------
    public removePermission(permissionId: string) { 

        var index = this.permissions.map(function (feature) { return feature.id; }).indexOf(permissionId); 
        this.permissions.splice(index);

    }
    //----------------------------------------------------------
    //getPermission
    //----------------------------------------------------------
    public getPermission(permissionID: string) {
        let permission: Feature;

        permission = this.permissions.find(perm => perm.id === permissionID);

        return permission;

    }
    
 
}
 
 



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authorization/permissions/permissions.service.ts